// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { slideshowStyles } from "@vanmeter/Overrides/Widgets/Basic/Slideshow";
import { fontConfig } from "@vanmeter/XDL/constants";
import { getSystemColor } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.iconProps = {
    size: 18,
    color: "common.ui4",
};

slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        width: 100%;
        margin-top: 16px;
    `,
};

slideshowStyles.dotButton = {
    css: css`
        border: 1px solid ${getSystemColor("common.ui4")};
        background: transparent;
        border-radius: 100%;
        width: 10px;
        height: 10px;
        padding: 0;
        min-height: unset;

        &.selected {
            border-color: ${getSystemColor("common.ui5")};
            background: ${getSystemColor("common.ui5")};
        }

        &:hover {
            border-color: ${getSystemColor("common.ui3")};
            background: ${getSystemColor("common.ui3")};
        }
    `,
};

slideshowStyles.pauseButton = {
    css: css`
        margin-left: 12px;
        display: flex;
        align-items: center;
    `,
};

slideshowStyles.pauseIcon = {
    color: "common.ui4",
    css: css`
        font-size: ${fontConfig.regular.size}px;
        line-height: ${fontConfig.regular.lineHeight};
        &:not(.active) {
            &:hover {
                color: ${getSystemColor("common.ui9")};
            }
            &:focus {
                color: ${getSystemColor("common.ui8")};
            }
        }
    `,
};

slideshowStyles.nextArrowWrapper = {
    css: css`
        display: flex;
        button {
            display: flex;
        }
    `,
};

slideshowStyles.nextArrowButton = {
    variant: "link" as any,
    css: css`
        margin-left: 16px;
    `,
};

slideshowStyles.prevArrowButton = {
    variant: "link" as any,
    css: css`
        margin-right: 16px;
    `,
};

slideshowStyles.prevArrowWrapper = {
    css: css`
        display: flex;
        button {
            display: flex;
        }
    `,
};
